
export enum PublicTransportDownloadStatus {
    InProgress = 1,
    Complete = 2,
    Failed = 3,
    PendingReview = 4
}

export const getPublicTransportDownloadStatusLabel = (importType: PublicTransportDownloadStatus) => {
  switch (importType) {
    case PublicTransportDownloadStatus.InProgress:
        return "In Progress";
    case PublicTransportDownloadStatus.Complete:
        return "Completed";
    case PublicTransportDownloadStatus.Failed:
        return "Failed";
    case PublicTransportDownloadStatus.PendingReview:
        return "Pending Review";
  }
}